exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rct-checkbox,.rct-radio{display:block;vertical-align:middle}.rct-checkbox *,.rct-radio *{vertical-align:middle}.rct-checkbox input,.rct-radio input{margin-right:5px}.rct-checkbox-group.rct-inline .rct-checkbox,.rct-checkbox-group.rct-inline .rct-radio,.rct-radio-group.rct-inline .rct-checkbox,.rct-radio-group.rct-inline .rct-radio{display:inline-block;margin-right:10px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?localIdentName=[hash:base64:8]!./~/less-loader!./src/themes/pure/checkbox.less
 ** module id = 194
 ** module chunks = 0
 **/